import axios from 'axios'
import { Toast, Notify } from 'vant'
import { getToken } from '@/utils/auth'
import { tansParams } from '@/utils/ruoyi'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  baseURL: '/api/',
  timeout: 30000
})

service.interceptors.request.use(config => {
  const isToken = (config.headers || {}).isToken === false
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  if (getToken() && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
  }
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params)
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  if (config.method === 'get') {
    config.headers['Cache-Control'] = 'no-cache'
    config.headers['Pragma'] = 'no-cache'
    const sep = (config.url || '').indexOf('?') === -1 ? '?' : '&'
    config.url = (config.url || '') + sep + '_t=' + Date.now()
  }
  if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const requestSize = Object.keys(JSON.stringify(requestObj)).length
    const limitSize = 5 * 1024 * 1024
    if (requestSize >= limitSize) {
      console.warn('[' + config.url + ']: 请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
      return config
    }
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(res => {
  const code = res.data.code || 200
  const msg = res.data.msg || '系统未知错误'
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }
  if (code === 401) {
    Toast.fail(msg)
    return Promise.reject(new Error(msg))
  } else if (code === 500) {
    Toast.fail(msg)
    return Promise.reject(new Error(msg))
  } else if (code === 601) {
    Toast.fail(msg)
    return Promise.reject('error')
  } else if (code !== 200) {
    Notify({ type: 'danger', message: msg })
    return Promise.reject('error')
  } else {
    return res.data
  }
}, error => {
  console.log('err' + error)
  let { message } = error
  if (message === 'Network Error') {
    message = '后端接口连接异常'
  } else if (message.includes('timeout')) {
    message = '系统接口请求超时'
  } else if (message.includes('Request failed with status code')) {
    message = '系统接口' + message.substr(message.length - 3) + '异常'
  }
  Toast.fail(message)
  return Promise.reject(error)
})

export default service
